import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=06289b8e&scoped=true"
import script from "./ScrollButton.vue?vue&type=script&lang=js"
export * from "./ScrollButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollButton.vue?vue&type=style&index=0&id=06289b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06289b8e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ScrollButton.vue
// module id = 27
// module chunks = 0